export default function calcVh() {
  function calculate() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  
  calculate();

  window.addEventListener("orientationchange", function () {
    setTimeout(calculate, 100);
  });

  // setTimeout(calculate, 100);
  // window.addEventListener('resize', calculate);
}